import React from 'react';
import queryString from 'querystring';
import PreAuthFormHolder from '../components/boxes/PreAuthFormHolder';
import MessageHolder from '../components/boxes/MessageHolder';
import ResetPasswordForm from '../components/forms/ResetPasswordForm';
import userService from '../services/userService';
import LoadingScreen from '../components/LoadingScreen';
import { Link } from 'react-router-dom';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      token: queryString.parse(props.location.search.substr(1)).token,
      isExpired: Date.now() > Date.parse(queryString.parse(props.location.search.substr(1)).expiry),
      error: null,
      loading: false,
      success: false
    }
  }

  checkPasswordMatch(values) {
    if (values.password === values.confirm_password) {
      return true;
    }
    return false;
  }

  resetPassword = (values) => {
    const match = this.checkPasswordMatch(values);

    if (match) {
      this.setState({loading: true})
      userService.resetPassword(values)
        .then(() => {
          this.setState({
            loading: false,
            success: true
          })
        })
        .catch(e => {
          this.setState({
            error: e.message,
            loading: false,
          })
        })
    } else {
      this.setState({error: 'Password and Confirm Password do not match'})
    }
  }

  renderSuccessMessage() {
    return (
      <PreAuthFormHolder>
        <MessageHolder>
          <h3>Password Reset Successful!</h3>
          <p>
            Login <Link to="/">here</Link> to access your dashboards.
          </p>
        </MessageHolder>
      </PreAuthFormHolder>
    )
  }

  renderExpiredMessage() {
    return (
      <PreAuthFormHolder>
        <MessageHolder>
          <h3>Reset link expired!</h3>
          <p>
            This link to reset your password has expired
          </p>
        </MessageHolder>
      </PreAuthFormHolder>
    )
  }

  render() {
    const {token, isExpired, error, loading, success} = this.state;

    if (loading) return <LoadingScreen />;

    if (success) return this.renderSuccessMessage();

    if (isExpired) return this.renderExpiredMessage();

    return (
      <PreAuthFormHolder message={error && error}>
        <ResetPasswordForm onSubmit={this.resetPassword} initialValues={{token}}/>
      </PreAuthFormHolder>
    )
  }
}

export default ResetPassword
